export default __webpack_public_path__ + "static/media/step2.254b9c4f.svg";